// export const BACKEND_URL = "http://localhost:8000/";
export const BACKEND_URL = "/";
export const demoConfig = {
  b2cAttendants: {
    title: "How to use Attendants dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/B2Cattendants.mp4",
  },
  b2cValets: {
    title: "How to use Valet dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/B2Cvalet.mp4",
  },
  b2cBellmen: {
    title: "How to use Bell Desk dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/B2Cbelldesk.mp4",
  },
  b2bAttendants: {
    title: "How to use Attendants dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/Attendants%20B2B%20Demo.mp4",
  },
  b2bValets: {
    title: "How to use Valet dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/B2Bvalet%20-%20Made%20with%20Clipchamp.mp4",
  },
  b2bBellmen: {
    title: "How to use Bell Desk dashboard",
    videoUrl:
      "https://storage.googleapis.com/tipkit-training-videos/B2Bbelldesk%20-%20Made%20with%20Clipchamp.mp4",
  },
};

export const onboardingDocs = {
  b2c: {
    onBoardHotel:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourHotel-B2C.pdf",
    onBoardUnits:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourUnits-B2C.pdf",
    onBoardTeam:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/Tipkit-OnboardingYourTeam.pdf",

    attendants:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/Tipkit-RoomAttendantGuide-english.pdf",
    valet:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/Tipkit-ValetGuide-english.pdf",
    belldesk:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/Tipkit-BelldeskGuide-english.pdf",
  },
  b2b: {
    onBoardHotel:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourHotel-B2B.pdf",
    onBoardUnits:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourUnits-BNB.pdf",
    onBoardTeam:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/Tipkit-OnboardingYourTeam.pdf",

    attendants:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourHotel-B2B.pdf",
    valet:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourHotel-B2B.pdf",
    belldesk:
      "https://storage.googleapis.com/tipkit-website-docs/onboarding-docs/OnboardingYourHotel-B2B.pdf",
  },
};

export const marketingDocs = {
  salesDeck:
    "https://storage.googleapis.com/tipkit-website-docs/marketing-docs/Tipkit%20sales%20deck.Dec.2025.pdf",
  tipkitParksDeck:
    "https://storage.googleapis.com/tipkit-website-docs/marketing-docs/tipkit%20for%20public%20spaces.pdf.pdf",
  tipkitOnePager:
    "https://storage.googleapis.com/tipkit-website-docs/marketing-docs/tipkit-one-pager.2026.pdf",
};
